<template>
  <v-app class="rounded-card">
    <v-snackbar
      v-if="this.role == 'พยาบาล'"
      v-model="snackbar"
      top
      right
      :timeout="timeout"
    >
      <div class="text-subtitle-1 pb-2">สายโทรเข้า...</div>

      <p>{{ snackbar_name }}</p>

      <template>
        <v-btn color="red" @click="declineBtn()"> ปฏิเสธ </v-btn>
        <v-btn class="ml-3" color="green" @click="openConference()">
          ตอบรับ
        </v-btn>
      </template>

      <audio id="audio" loop>
        <source src="@/assets/sounds/ringtone.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.</audio
      ><br />
    </v-snackbar>
    <v-snackbar
      v-if="this.role == 'แพทย์'"
      v-model="snackbar"
      top
      right
      :timeout="timeout"
    >
      <div class="text-subtitle-1 pb-2">สายโทรเข้า...</div>

      <p>{{ snackbar_name }}</p>

      <template>
        <v-btn color="red" @click="declineBtn"> ปฏิเสธ </v-btn>
        <v-btn class="ml-3" color="green" @click="openConference">
          ตอบรับ
        </v-btn>
      </template>

      <audio id="audio" loop>
        <source src="@/assets/sounds/ringtone.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.</audio
      ><br />
    </v-snackbar>
    <v-app-bar
      dense
      app
      absolute
      class="pt-5"
      flat
      elevation="0"
      color="transparent"
    >
      <v-toolbar-title>
        <v-row class="pa-0 ma-0">
          <v-col
            :class="$vuetify.breakpoint.smAndDown ? 'pl-0 mt-1' : 'pl-0 mt-2'"
          >
            <span
              :class="
                $vuetify.breakpoint.smAndDown
                  ? 'w-400 font-14 text-white'
                  : 'w-700 font-22 text-white'
              "
            >
              {{ displayTemplate(profile && profile.account_detail, "bizId") }}
            </span>
          </v-col>
        </v-row>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-row class="d-flex flex-row pa-0 ma-0" justify-lg="end">
        <v-spacer></v-spacer>
        <v-col
          v-if="this.role == 'แพทย์' || this.role == 'เภสัชกร'"
          :cols="almost_mobile ? '3' : 'auto'"
          class="pt-2 pb-2 d-flex align-center card-profile"
        >
          <v-select
            flat
            solo
            dense
            hide-details="auto"
            color="#00a99d"
            :menu-props="{ bottom: true, offsetY: true }"
            item-color="#00a99d"
            v-model="selectClinic"
            class="ma-0 card-profile"
            :items="getDataSelectClinic"
            item-text="first_name_th"
            item-value="biz_id"
            @change="changBiz_id()"
          ></v-select>
        </v-col>
        <v-col
          v-else
          :cols="almost_mobile ? '3' : 'auto'"
          class="pt-2 pb-2 d-flex align-center card-hosname"
        >
          <div class="card-hosname-text">{{ hos_name }}</div>
        </v-col>
        <!-- notification -->
        <v-col
          v-if="
            this.role == 'แพทย์' ||
            this.role == 'เภสัชกร' ||
            ((this.role == 'พยาบาล' || this.role == 'เจ้าหน้าที่เวชระเบียน') &&
              this.Storage_bizid == '668236676897760')
          "
          cols="auto"
          class="ml-2 pt-2 pb-2 d-flex align-center card-profile"
        >
          <v-menu
            offset-y
            transition="slide-y-transition"
            :close-on-content-click="statusnoti"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="playSound" icon class="mr-1">
                <v-badge
                  :content="messages"
                  :value="messages"
                  color="red"
                  overlap
                  ><v-icon dark size="21" color="#00a99d"> mdi-bell </v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card
              height="500"
              width="360"
              style="overflow-y: scroll"
              class="custom-scrollbar pa-0"
            >
              <v-card-title>
                <v-row>
                  <v-col cols="4">
                    <span class="w-700 font-16 black--text">การแจ้งเตือน</span>
                  </v-col>
                  <v-col cols="8">
                    <v-row>
                      <span class="font-12 mt-4 ml-6 pl-5"
                        >แสดงเฉพาะที่ยังไม่อ่าน</span
                      >
                      <v-switch
                        v-model="unread"
                        inset
                        color="#00a99d"
                        class="ma-0 mt-4 ml-3"
                      ></v-switch>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider class="linedivider"></v-divider>
              <v-card-text v-if="unread == false">
                <v-list v-for="(item, i) in orderDetail" :key="i">
                  <v-card
                    width="410"
                    color="#ebf7f7"
                    @click="selectNotification(item)"
                    class="card-profile"
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          style="
                            font-size: 12px;
                            display: flex;
                            align-self: center;
                          "
                        >
                          <v-icon v-show="item.is_read == false" color="red"
                            >mdi-circle-small</v-icon
                          >
                          <v-icon
                            color="#00a99d"
                            class="mr-2 mb-1"
                            style="
                              display: flex;
                              align-self: center;
                              margin-bottom: 0 !important;
                            "
                            >mdi-account</v-icon
                          ><span
                            :style="
                              item.is_read == false
                                ? 'color:#00a99d; font-size: 16px; font-weight:600;'
                                : 'font-size: 16px; font-weight:600;'
                            "
                            style="display: flex; align-self: center"
                            ><span
                              v-if="
                                role == 'เภสัชกร' || item.type.includes('drug')
                              "
                              style="display: flex; align-self: center"
                              >รายการยาของ </span
                            >{{ item.details.patient_name }}</span
                          >
                          <span
                            v-if="role == 'แพทย์'"
                            style="display: flex; align-self: center"
                            >&nbsp;({{ item.details.org_name }})</span
                          >
                        </v-list-item-subtitle>
                        <v-list-item-subtitle
                          style="
                            font-size: 12px;
                            font-weight: 600;
                            white-space: pre-line;
                            text-indent: 1em;
                            line-height: 1.7rem;
                          "
                          >{{ item.details.message }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle
                          style="font-size: 12px; text-indent: 1em"
                          >{{
                            formatDateTime(item.createdAt)
                          }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-list>
              </v-card-text>
              <infinite-loading v-show="!unread" @infinite="getDataList"
                ><span slot="no-results"></span
              ></infinite-loading>
              <v-card-text v-if="unread == true">
                <v-list v-for="(item, i) in orderDetail_unread" :key="i">
                  <v-card
                    width="410"
                    color="#ebf7f7"
                    @click="selectNotification(item)"
                    class="mt-0 card-profile"
                  >
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          style="
                            font-size: 12px;
                            display: flex;
                            align-self: center;
                          "
                        >
                          <v-icon
                            v-show="item.is_read == false"
                            color="red"
                            style="
                              display: flex;
                              align-self: center;
                              margin-bottom: 0 !important;
                            "
                            >mdi-circle-small</v-icon
                          >
                          <v-icon color="#00a99d" class="mr-2 mb-1"
                            >mdi-account</v-icon
                          ><span
                            :style="
                              item.is_read == false
                                ? 'color:#00a99d; font-size: 16px; font-weight:600;'
                                : 'font-size: 16px; font-weight:600;'
                            "
                            style="display: flex; align-self: center"
                            ><span
                              v-if="
                                role === 'เภสัชกร' || item.type.includes('drug')
                              "
                              style="display: flex; align-self: center"
                              >รายการยาของ </span
                            >{{ item.details.patient_name }}</span
                          >
                          <span
                            v-if="role == 'แพทย์'"
                            style="display: flex; align-self: center"
                            >&nbsp;({{ item.details.org_name }})</span
                          >
                        </v-list-item-subtitle>
                        <v-list-item-subtitle
                          style="
                            font-size: 12px;
                            font-weight: 600;
                            white-space: pre-line;
                            text-indent: 1em;
                          "
                          >{{ item.details.message }}</v-list-item-subtitle
                        >
                        <v-list-item-subtitle
                          style="font-size: 12px; text-indent: 1em"
                          >{{
                            formatDateTime(item.createdAt)
                          }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-list>
                <v-col
                  v-show="this.messages == 0"
                  cols="12"
                  class="ml-4 pl-5 pb-4 pt-0"
                >
                  <v-img
                    width="250"
                    height="250"
                    src="@/assets/image/notification.png"
                  ></v-img>
                </v-col>
                <v-col
                  v-show="this.messages == 0"
                  align="center"
                  justify="center"
                >
                  <span class="ma-0">ไม่มีแจ้งเตือนที่ยังไม่ได้อ่านค่ะ</span>
                </v-col>
              </v-card-text>
              <infinite-loading v-show="unread" @infinite="getDataListUnread"
                ><span slot="no-results"></span
              ></infinite-loading>
            </v-card>
          </v-menu>
        </v-col>
        <!-- ---------------------------- -->
        <v-col cols="auto" class="ml-2 card-profile">
          <div class="d-flex flex-row">
            <div class="d-flex align-center" align="left" v-if="!almost_mobile">
              <v-avatar color="#00a99d" size="38" class="mr-2">
                <v-icon dark> mdi-account-circle </v-icon>
              </v-avatar>
              <div class="d-flex flex-column" v-if="!almost_mobile">
                <span
                  :class="
                    $vuetify.breakpoint.smAndDown
                      ? 'font-12 text-333333 w-400'
                      : 'font-16 text-333333 w-400'
                  "
                  dark
                  >{{ displayTemplate("name") || "-" }}</span
                >
                <span
                  :class="
                    $vuetify.breakpoint.smAndDown
                      ? 'font-10 text-333333 w-400'
                      : 'font-14 text-333333 w-400'
                  "
                  >({{ displayTemplate("role") || "-" }})</span
                >
              </div>
            </div>
            <div class="ml-auto" style="align-self: center">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn small icon v-on="on" class="ml-3" color="#00a99d">
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>

                <v-list class="pa-0">
                  <v-list-item v-if="almost_mobile">
                    <v-list-item-icon>
                      <v-icon> mdi-account-circle </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ displayTemplate("name") || "-" }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        >({{
                          displayTemplate("role") || "-"
                        }})</v-list-item-subtitle
                      ></v-list-item-content
                    >
                  </v-list-item>

                  <v-list-item class="pt-2" v-if="this.role == 'แพทย์'">
                    <v-switch
                      v-model="status"
                      inset
                      hide-details
                      class="ma-0"
                      color="#00a99d"
                      @change="changeStatusWorking(status)"
                    ></v-switch>
                    <v-list-item-title class="custom-text">
                      {{ status == true ? "ออนไลน์" : "ออฟไลน์" }}
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item v-if="is_doctor" @click="go_to_doctor_profile()">
                    <v-list-item-icon>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="custom-text">
                      โปรไฟล์
                    </v-list-item-title>
                  </v-list-item>
                  <!-- ---- เปลี่ยนสิทธิ์ ---- -->
                  <v-list-item
                    v-if="
                      this.role !== 'แพทย์' &&
                      this.role !== 'เภสัชกร' &&
                      this.role !== 'ehp_redirect' &&
                      this.loginWithRedirect !== 'loginWithRedirect'
                    "
                    @click="openDialogRole()"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-account-arrow-right-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="custom-text"
                      >เปลี่ยนสิทธิ์
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="logout()">
                    <v-list-item-icon>
                      <v-icon>mdi-import</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="custom-text">
                      ออกจากระบบ
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
          <!-- เลือกสิทธิ์ อีกตัวเลือก-->
          <v-dialog v-model="dialog" width="600" scrollable>
            <v-card :tile="xs_mode">
              <v-card-title
                class="black--text text_header font-weight-bold"
                :class="xs_mode ? 'py-3 px-4' : ''"
              >
                <v-btn disabled icon></v-btn>
                <v-spacer></v-spacer>
                เปลี่ยนสิทธิ์
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" icon class="float-right">
                  <v-icon>mdi-window-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text :class="xs_mode ? 'pt-2' : 'pt-2 px-10'"
                ><v-row align="center" justify="center">
                  <v-col cols="12" sm="8" class="py-1"
                    ><h3>เลือกสิทธิ์</h3>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-radio-group v-model="changeRole" required>
                      <v-radio
                        color="#00a99d"
                        v-for="(item, n) in roleList"
                        :key="n"
                        :label="item"
                        :value="item"
                      ></v-radio
                    ></v-radio-group> </v-col></v-row
                ><v-row align="center" justify="center"
                  ><v-col cols="5" sm="4" md="3"
                    ><v-btn
                      class="rounded-lg"
                      block
                      color="#00a99d"
                      outlined
                      @click="dialog = false"
                      >ยกเลิก</v-btn
                    ></v-col
                  ><v-col cols="5" sm="4" md="3"
                    ><v-btn
                      class="rounded-lg"
                      dark
                      block
                      color="#00a99d"
                      :loading="btn_loading"
                      @click="confirmChangeRole()"
                      >ยืนยัน</v-btn
                    ></v-col
                  ></v-row
                ></v-card-text
              >
              <v-card-actions> </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <!-- snackbar button -->
      <!-- <div>
        <v-btn dark color="#00a99d" @click="incomingCall"> Open Snackbar </v-btn>
      </div> -->

      <!-- profile -->
      <div
        class="card-profile"
        :style="almost_mobile ? '' : 'min-width: 180px'"
        v-if="false"
      >
        <div class="d-flex flex-row">
          <div class="d-flex align-center" align="left" v-if="!almost_mobile">
            <v-avatar color="#00a99d" size="38" class="mr-2">
              <v-icon dark> mdi-account-circle </v-icon>
            </v-avatar>
            <div class="d-flex flex-column" v-if="!almost_mobile">
              <span
                :class="
                  $vuetify.breakpoint.smAndDown
                    ? 'font-12 text-333333 w-400'
                    : 'font-16 text-333333 w-400'
                "
                dark
                >{{ displayTemplate("name") || "-" }}</span
              >
              <span
                :class="
                  $vuetify.breakpoint.smAndDown
                    ? 'font-10 text-333333 w-400'
                    : 'font-14 text-333333 w-400'
                "
                >({{ displayTemplate("role") || "-" }})</span
              >
            </div>
          </div>
          <div class="ml-auto" style="align-self: center">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn small icon v-on="on" class="ml-3" color="#00a99d">
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list class="pa-0">
                <v-list-item v-if="almost_mobile">
                  <v-list-item-icon>
                    <v-icon> mdi-account-circle </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ displayTemplate("name") || "-" }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      >({{
                        displayTemplate("role") || "-"
                      }})</v-list-item-subtitle
                    ></v-list-item-content
                  >
                </v-list-item>

                <v-list-item class="pt-2" v-if="this.role == 'แพทย์'">
                  <v-switch
                    v-model="status"
                    inset
                    hide-details
                    class="ma-0"
                    color="#00a99d"
                    @change="changeStatusWorking(status)"
                  ></v-switch>
                  <v-list-item-title class="custom-text">
                    {{ status == true ? "ออนไลน์" : "ออฟไลน์" }}
                  </v-list-item-title>
                </v-list-item>

                <v-list-item v-if="is_doctor" @click="go_to_doctor_profile()">
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="custom-text">
                    โปรไฟล์
                  </v-list-item-title>
                </v-list-item>

                <v-list-item @click="logout()">
                  <v-list-item-icon>
                    <v-icon>mdi-import</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="custom-text">
                    ออกจากระบบ
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      app
      touchless
      floating
      fixed
      class="rounded-card"
      mini-variant-width="70"
      permanent
      height="100%"
      v-if="!mini"
      ><!-- clipped -->
      <template v-slot:prepend>
        <v-row class="px-3 pt-5 pb-3" style="text-align-last: center">
          <v-col cols="12" align-self="center">
            <v-avatar
              alt="logostc"
              color="#ffffff"
              size="70%"
              rounded
              style="border: 3px solid #ffffff"
              v-if="organization_vuex.organize_logo"
            >
              <v-img
                :src="organization_vuex.organize_logo"
                @click.stop="mini = !mini"
              />
            </v-avatar>
            <v-avatar
              alt="logostc"
              color="#ffffff"
              size="100%"
              rounded
              style="border: 3px solid #ffffff"
              v-else
            >
              <v-img
                :src="require(`@/assets/icon/logo.svg`)"
                @click.stop="mini = !mini"
              />
            </v-avatar>
          </v-col>
          <!-- <v-col v-if="mini === false" cols="8" align-self="center" class="pr-0 custom-topic">
            <span class="text-white w-700 font-16">{{ hos_name }}</span>
          </v-col> -->
        </v-row>
      </template>

      <v-list nav flat dense dark>
        <!-- {{ itemsPermission }} -->
        <div v-for="(item, index) in itemsPermission" :key="item.title">
          <div v-if="item.show == true && item.title !== 'เยี่ยมบ้าน'">
            <!-- home visit -->
            <v-list-group
              v-if="
                item.title == 'รายการเยี่ยมบ้าน' &&
                item.items.length != 0 &&
                itemsShow(item.items)
              "
              active-class="hover-menu-bar"
              dark
              color="white"
              mandatory
            >
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        v-bind="attrs"
                        v-on="on"
                        v-if="
                          (tab === index && openTab !== false) ||
                          (openTab !== false && tab === '3.0') ||
                          (openTab !== false && tab === '3.1')
                        "
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.imgActive}`)"
                        width="30px"
                        height="30px"
                      />
                      <v-img
                        v-bind="attrs"
                        v-on="on"
                        v-else
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.img}`)"
                        width="30px"
                        height="30px"
                      />
                    </template>
                    <span class="text-white">{{ item.title }}</span>
                  </v-tooltip>
                </v-list-item-icon>

                <v-list-item-content
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '3.0') ||
                    (openTab !== false && tab === '3.1')
                  "
                >
                  <v-list-item-title class="text-00A99D">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-list-item-title class="text-white">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <div v-if="'items' in item">
                <div v-for="(title, i) in item.items" :key="i">
                  <v-list-item
                    v-if="title.show"
                    active-class="hover-menu-bar"
                    :to="title.path"
                    class="ml-6 pb-1"
                    @click="activeTab('2.' + i)"
                    dark
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ title.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </v-list-group>

            <!-- telemed -->
            <v-list-group
              v-else-if="
                item.title == 'Telemedicine' &&
                item.items.length != 0 &&
                itemsShow(item.items)
              "
              active-class="hover-menu-bar"
              dark
              color="white"
              mandatory
            >
              <template v-slot:activator>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-icon v-bind="attrs" v-on="on">
                      <v-icon size="25" color="white"
                        >mdi mdi-hospital-building</v-icon
                      >
                    </v-list-item-icon>
                  </template>
                  <span class="text-white">{{ item.title }}</span>
                </v-tooltip>

                <v-list-item-content
                  :value="openTabTelemed"
                  @click="activeTab(index)"
                  @change="openTabTelemed = !openTabTelemed"
                >
                  <v-list-item-title class="text-white">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <div v-if="'items' in item">
                <div v-for="(title, i) in item.items" :key="i">
                  <v-list-item
                    v-if="title.show"
                    active-class="hover-menu-bar"
                    :to="title.path"
                    class="ml-6 pb-1"
                    @click="activeTab('3.' + i)"
                    dark
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{ title.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </v-list-group>
            <!-- telepharma  -->
            <v-list-group
              v-else-if="
                item.title == 'Telepharmacy' &&
                item.items.length != 0 &&
                itemsShow(item.items)
              "
              dark
              mandatory
            >
              <template v-slot:appendIcon>
                <v-icon
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '4.0') ||
                    (openTab !== false && tab === '4.1')
                  "
                  color="#FFFFFF"
                  >mdi-chevron-down</v-icon
                >
                <v-icon v-else color="#FFFFFF">mdi-chevron-down</v-icon>
              </template>

              <template v-slot:activator>
                <v-list-item-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        v-bind="attrs"
                        v-on="on"
                        v-if="
                          (tab === index && openTab !== false) ||
                          (openTab !== false && tab === '4.0') ||
                          (openTab !== false && tab === '4.1')
                        "
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.imgActive}`)"
                        width="30px"
                        height="30px"
                      />
                      <v-img
                        v-bind="attrs"
                        v-on="on"
                        v-else
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.img}`)"
                        width="30px"
                        height="30px"
                      />
                    </template>
                    <span class="text-white">{{ item.title }}</span>
                  </v-tooltip>
                </v-list-item-icon>

                <v-list-item-content
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '4.0') ||
                    (openTab !== false && tab === '4.1')
                  "
                >
                  <v-list-item-title class="text-00A99D">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-list-item-title class="text-white">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <div v-if="'items' in item">
                <div v-for="(title, i) in item.items" :key="i">
                  <v-list-item
                    v-if="title.show"
                    active-class="hover-menu-bar"
                    :to="title.path"
                    class="ml-6 pb-1"
                    @click="activeTab('4.' + i)"
                    dark
                  >
                    <v-list-item-content
                      :value="openTab"
                      :active-class="
                        (tab === index && openTab !== false) ||
                        (openTab !== false && tab === '4.0') ||
                        (openTab !== false && tab === '4.1')
                          ? 'white'
                          : ''
                      "
                      @click="activeTab(index)"
                      @change="openTab = !openTab"
                    >
                      <v-list-item-title>{{ title.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </v-list-group>
            <!-- ผลตรวจสุขภาพ -->
            <v-list-group
              v-else-if="
                item.title == 'ตรวจสุขภาพ' &&
                item.items.length != 0 &&
                itemsShow(item.items)
              "
              dark
              mandatory
            >
              <template v-slot:appendIcon>
                <v-icon
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '4.0') ||
                    (openTab !== false && tab === '4.1')
                  "
                  color="#FFFFFF"
                  >mdi-chevron-down</v-icon
                >
                <v-icon v-else color="#FFFFFF">mdi-chevron-down</v-icon>
              </template>

              <template v-slot:activator>
                <v-list-item-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        v-bind="attrs"
                        v-on="on"
                        v-if="
                          (tab === index && openTab !== false) ||
                          (openTab !== false && tab === '4.0') ||
                          (openTab !== false && tab === '4.1')
                        "
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.imgActive}`)"
                        width="30px"
                        height="30px"
                      />
                      <v-img
                        v-bind="attrs"
                        v-on="on"
                        v-else
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.img}`)"
                        width="30px"
                        height="30px"
                      />
                    </template>
                    <span class="text-white">{{ item.title }}</span>
                  </v-tooltip>
                </v-list-item-icon>

                <v-list-item-content
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '4.0') ||
                    (openTab !== false && tab === '4.1')
                  "
                >
                  <v-list-item-title class="text-00A99D">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-list-item-title class="text-white">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <div v-if="'items' in item">
                <div v-for="(title, i) in item.items" :key="i">
                  <v-list-item
                    v-if="title.show"
                    active-class="hover-menu-bar"
                    :to="title.path"
                    class="ml-6 pb-1"
                    @click="activeTab('4.' + i)"
                    dark
                  >
                    <v-list-item-content
                      :value="openTab"
                      :active-class="
                        (tab === index && openTab !== false) ||
                        (openTab !== false && tab === '4.0') ||
                        (openTab !== false && tab === '4.1')
                          ? 'white'
                          : ''
                      "
                      @click="activeTab(index)"
                      @change="openTab = !openTab"
                    >
                      <v-list-item-title>{{ title.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </v-list-group>

            <!-- ManageClinic -->
            <v-list-item
              v-else-if="
                item.title == 'จัดการข้อมูล' && showManageClinic == true
              "
              dark
              active-class="hover-menu-bar"
              :to="item.path"
              @click="activeTab(index)"
            >
              <v-list-item-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-bind="attrs"
                      v-on="on"
                      v-if="tab === index"
                      :alt="item.alt"
                      :src="require(`@/assets/icon/${item.imgActive}`)"
                      width="30px"
                      height="30px"
                    />
                    <v-img
                      v-bind="attrs"
                      v-on="on"
                      v-else
                      :alt="item.alt"
                      :src="require(`@/assets/icon/${item.img}`)"
                      width="30px"
                      height="30px"
                    />
                  </template>
                  <span>{{ item.title }}</span>
                </v-tooltip>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-else
              dark
              active-class="hover-menu-bar"
              :to="item.path"
              @click="activeTab(index)"
            >
              <v-list-item-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-bind="attrs"
                      v-on="on"
                      v-if="tab === index"
                      :alt="item.alt"
                      :src="require(`@/assets/icon/${item.imgActive}`)"
                      width="30px"
                      height="30px"
                    />
                    <v-img
                      v-bind="attrs"
                      v-on="on"
                      v-else
                      :alt="item.alt"
                      :src="require(`@/assets/icon/${item.img}`)"
                      width="30px"
                      height="30px"
                    />
                  </template>
                  <span>{{ item.title }}</span>
                </v-tooltip>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>
      </v-list>

      <template v-slot:append>
        <v-row justify="center">
          <v-col align="center" class="pb-8">
            <span class="text-white w-500 font-16">Version 1.1.15</span>
          </v-col>
        </v-row>
      </template>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      app
      touchless
      floating
      fixed
      class="rounded-card"
      mini-variant-width="85"
      permanent
      height="100%"
      v-else
      ><!-- clipped -->
      <template v-slot:prepend>
        <v-row class="px-3 py-5" style="text-align: center">
          <v-col cols="12" align-self="center">
            <v-avatar
              alt="logostc"
              color="#ffffff"
              size="60"
              style="border: 3px solid #ffffff"
            >
              <v-img :src="organization_vuex.organize_logo" />
            </v-avatar>
          </v-col>
        </v-row>
      </template>

      <v-list nav flat dense dark>
        <!-- {{ itemsPermission }} -->
        <div v-for="(item, index) in itemsPermission" :key="item.title">
          <div v-if="item.show == true && item.title !== 'เยี่ยมบ้าน'">
            <!-- telepharma  -->
            <v-list-group
              v-if="
                item.title == 'รายการเยี่ยมบ้าน' &&
                item.items.length != 0 &&
                itemsShow(item.items)
              "
              dark
              mandatory
              style="text-align: center"
            >
              <template v-slot:appendIcon>
                <v-icon
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '2.0') ||
                    (openTab !== false && tab === '2.1')
                  "
                  color="#FFFFFF"
                  >mdi-chevron-down</v-icon
                >
                <v-icon v-else color="#FFFFFF">mdi-chevron-down</v-icon>
              </template>

              <template v-slot:activator>
                <v-list-item-icon
                  style="margin-bottom: 30px"
                  class="pb-1"
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '2.0') ||
                    (openTab !== false && tab === '2.1')
                  "
                >
                  <v-row>
                    <v-col
                      cols="12"
                      class="pt-3 pb-0"
                      style="align-items: center; text-align: -webkit-center"
                    >
                      <v-img
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.imgActive}`)"
                        width="25px"
                        height="25px"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="pt-0 pb-1"
                      style="
                        text-wrap: balance !important;
                        text-align: -webkit-center;
                      "
                    >
                      <span class="text-white font-12">{{ item.title }}</span>
                    </v-col>
                  </v-row>
                </v-list-item-icon>
                <v-list-item-icon
                  style="margin-bottom: 50px"
                  class="pb-1"
                  v-else
                >
                  <v-row>
                    <v-col
                      cols="12"
                      class="pt-3 pb-0"
                      style="align-items: center; text-align: -webkit-center"
                    >
                      <v-img
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.img}`)"
                        width="25px"
                        height="25px"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="pt-0 pb-1"
                      style="
                        text-wrap: balance !important;
                        text-align: -webkit-center;
                      "
                    >
                      <span class="text-white font-12">{{ item.title }}</span>
                    </v-col>
                  </v-row>
                </v-list-item-icon>
              </template>

              <div v-if="'items' in item">
                <div v-for="(title, i) in item.items" :key="i">
                  <v-list-item
                    v-if="title.show"
                    active-class="hover-menu-bar"
                    :to="title.path"
                    @click="activeTab('2.' + i)"
                    dark
                    style="
                      margin-top: 5px;
                      border: 1px solid #ffffff;
                      padding: 0px 5px;
                    "
                  >
                    <v-list-item-content
                      :value="openTab"
                      :active-class="
                        (tab === index && openTab !== false) ||
                        (openTab !== false && tab === '2.0') ||
                        (openTab !== false && tab === '2.1')
                          ? 'white'
                          : ''
                      "
                      @click="activeTab(index)"
                      @change="openTab = !openTab"
                      style="padding-left: 0px !important"
                      class="py-0"
                    >
                      <v-list-item-title class="mt-0">
                        <v-row>
                          <v-col
                            cols="12"
                            style="text-wrap: balance !important"
                          >
                            <span style="font-size: 7px !important">{{
                              title.title
                            }}</span>
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </v-list-group>

            <!-- telemed -->
            <v-list-group
              v-else-if="
                item.title == 'Telemedicine' &&
                item.items.length != 0 &&
                itemsShow(item.items)
              "
              active-class="hover-menu-bar"
              dark
              color="white"
              mandatory
              style="text-align: center"
            >
              <template v-slot:activator>
                <v-list-item-icon style="margin-bottom: 12px">
                  <v-row>
                    <v-col cols="12" class="pt-1 pb-0">
                      <v-icon size="25" color="white"
                        >mdi mdi-hospital-building</v-icon
                      >
                    </v-col>
                    <v-col cols="12" class="pb-1 pt-0">
                      <span class="text-white font-12">{{ item.title }}</span>
                    </v-col>
                  </v-row>
                </v-list-item-icon>

                <v-list-item-content
                  :value="openTabTelemed"
                  @click="activeTab(index)"
                  @change="openTabTelemed = !openTabTelemed"
                  class="pb-1"
                >
                  <v-list-item-title>
                    <v-row>
                      <v-col
                        cols="12"
                        class="pt-1 pb-0"
                        style="text-wrap: balance !important"
                      >
                        <span
                          class="text-white"
                          style="font-size: 12px !important"
                          >{{ item.title }}</span
                        >
                      </v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <div v-if="'items' in item">
                <div v-for="(title, i) in item.items" :key="i">
                  <v-list-item
                    v-if="title.show"
                    active-class="hover-menu-bar"
                    :to="title.path"
                    @click="activeTab('3.' + i)"
                    dark
                    style="
                      margin-top: 5px;
                      border: 1px solid #ffffff;
                      padding: 0px 5px;
                    "
                  >
                    <v-list-item-content
                      style="padding-left: 0px !important"
                      class="py-0"
                    >
                      <v-list-item-title class="mt-0">
                        <v-row>
                          <v-col
                            cols="12"
                            style="text-wrap: balance !important"
                          >
                            <span style="font-size: 7px !important">{{
                              title.title
                            }}</span>
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </v-list-group>
            <!-- telepharma  -->
            <v-list-group
              v-else-if="
                item.title == 'Telepharmacy' &&
                item.items.length != 0 &&
                itemsShow(item.items)
              "
              dark
              mandatory
              style="text-align: center"
            >
              <template v-slot:appendIcon>
                <v-icon
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '4.0') ||
                    (openTab !== false && tab === '4.1')
                  "
                  color="#FFFFFF"
                  >mdi-chevron-down</v-icon
                >
                <v-icon v-else color="#FFFFFF">mdi-chevron-down</v-icon>
              </template>

              <template v-slot:activator>
                <v-list-item-icon
                  style="margin-bottom: 20px"
                  class="pb-1"
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '4.0') ||
                    (openTab !== false && tab === '4.1')
                  "
                >
                  <v-row>
                    <v-col
                      cols="12"
                      class="pt-3 pb-0"
                      style="align-items: center; text-align: -webkit-center"
                    >
                      <v-img
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.imgActive}`)"
                        width="25px"
                        height="25px"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="pt-0 pb-1"
                      style="
                        text-wrap: balance !important;
                        text-align: -webkit-center;
                      "
                    >
                      <span class="text-white font-12">{{ item.title }}</span>
                    </v-col>
                  </v-row>
                </v-list-item-icon>
                <v-list-item-icon
                  style="margin-bottom: 20px"
                  class="pb-1"
                  v-else
                >
                  <v-row>
                    <v-col
                      cols="12"
                      class="pt-3 pb-0"
                      style="align-items: center; text-align: -webkit-center"
                    >
                      <v-img
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.img}`)"
                        width="25px"
                        height="25px"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="pt-0 pb-1"
                      style="
                        text-wrap: balance !important;
                        text-align: -webkit-center;
                      "
                    >
                      <span class="text-white font-12">{{ item.title }}</span>
                    </v-col>
                  </v-row>
                </v-list-item-icon>
              </template>

              <div v-if="'items' in item">
                <div v-for="(title, i) in item.items" :key="i">
                  <v-list-item
                    v-if="title.show"
                    active-class="hover-menu-bar"
                    :to="title.path"
                    @click="activeTab('4.' + i)"
                    dark
                    style="
                      margin-top: 5px;
                      border: 1px solid #ffffff;
                      padding: 0px 5px;
                    "
                  >
                    <v-list-item-content
                      :value="openTab"
                      :active-class="
                        (tab === index && openTab !== false) ||
                        (openTab !== false && tab === '4.0') ||
                        (openTab !== false && tab === '4.1')
                          ? 'white'
                          : ''
                      "
                      @click="activeTab(index)"
                      @change="openTab = !openTab"
                      style="padding-left: 0px !important"
                      class="py-0"
                    >
                      <v-list-item-title class="mt-0">
                        <v-row>
                          <v-col
                            cols="12"
                            style="text-wrap: balance !important"
                          >
                            <span style="font-size: 7px !important">{{
                              title.title
                            }}</span>
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </v-list-group>

            <!-- ผลตรวจสุขภาพ -->
            <v-list-group
              v-else-if="
                item.title == 'ตรวจสุขภาพ' &&
                item.items.length != 0 &&
                itemsShow(item.items)
              "
              dark
              mandatory
              class="pb-1"
              style="text-align: center"
            >
              <template v-slot:appendIcon>
                <v-icon
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '4.0') ||
                    (openTab !== false && tab === '4.1')
                  "
                  color="#FFFFFF"
                  >mdi-chevron-down</v-icon
                >
                <v-icon v-else color="#FFFFFF">mdi-chevron-down</v-icon>
              </template>

              <template v-slot:activator>
                <v-list-item-icon
                  style="margin-bottom: 20px"
                  class="pb-1"
                  v-if="
                    (tab === index && openTab !== false) ||
                    (openTab !== false && tab === '4.0') ||
                    (openTab !== false && tab === '4.1')
                  "
                >
                  <v-row>
                    <v-col
                      cols="12"
                      class="pt-3 pb-0"
                      style="align-items: center; text-align: -webkit-center"
                    >
                      <v-img
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.imgActive}`)"
                        width="25px"
                        height="25px"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="pt-0 pb-1"
                      style="
                        text-wrap: nowrap !important;
                        text-align: -webkit-center;
                      "
                    >
                      <span class="text-white font-12">{{ item.title }}</span>
                    </v-col>
                  </v-row>
                </v-list-item-icon>
                <v-list-item-icon
                  style="margin-bottom: 20px"
                  class="pb-1"
                  v-else
                >
                  <v-row>
                    <v-col
                      cols="12"
                      class="pt-3 pb-0"
                      style="align-items: center; text-align: -webkit-center"
                    >
                      <v-img
                        :alt="item.alt"
                        :src="require(`@/assets/icon/${item.img}`)"
                        width="25px"
                        height="25px"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      class="pt-0 pb-1"
                      style="
                        text-wrap: nowrap !important;
                        text-align: -webkit-center;
                      "
                    >
                      <span class="text-white font-12">{{ item.title }}</span>
                    </v-col>
                  </v-row>
                </v-list-item-icon>
              </template>

              <div v-if="'items' in item">
                <div v-for="(title, i) in item.items" :key="i">
                  <v-list-item
                    v-if="title.show"
                    active-class="hover-menu-bar"
                    :to="title.path"
                    @click="activeTab('4.' + i)"
                    dark
                    :style="
                      title.title == 'Dashboard' ||
                      title.title == 'Dashboard Transaction'
                        ? 'margin-top: 5px; border: 1px solid #ffffff; padding: 0px 3px;'
                        : 'margin-top: 5px; border: 1px solid #ffffff; padding: 0px 5px;'
                    "
                  >
                    <v-list-item-content
                      :value="openTab"
                      :active-class="
                        (tab === index && openTab !== false) ||
                        (openTab !== false && tab === '4.0') ||
                        (openTab !== false && tab === '4.1')
                          ? 'white'
                          : ''
                      "
                      @click="activeTab(index)"
                      @change="openTab = !openTab"
                      style="padding-left: 0px !important"
                      class="py-0"
                    >
                      <v-list-item-title class="mt-0">
                        <v-row>
                          <v-col
                            v-if="title.title == 'Dashboard Transaction'"
                            cols="12"
                            style="text-wrap: balance !important"
                          >
                            <span style="font-size: 7px !important"
                              >Dashboard Transaction</span
                            >
                          </v-col>
                          <v-col
                            v-else
                            cols="12"
                            style="text-wrap: balance !important"
                          >
                            <span style="font-size: 7px !important">{{
                              title.title
                            }}</span>
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </div>
            </v-list-group>

            <!-- ManageClinic -->
            <v-list-item
              v-else-if="
                item.title == 'จัดการข้อมูล' && showManageClinic == true
              "
              dark
              active-class="hover-menu-bar"
              :to="item.path"
              @click="activeTab(index)"
            >
              <v-list-item-icon
                style="height: auto"
                class="pb-1"
                v-if="tab === index"
              >
                <v-row>
                  <v-col
                    cols="12"
                    class="pt-3 pb-0"
                    style="align-items: center; text-align: -webkit-center"
                  >
                    <v-img
                      :alt="item.alt"
                      :src="require(`@/assets/icon/${item.imgActive}`)"
                      width="25px"
                      height="25px"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    class="pt-0 pb-1"
                    style="
                      text-wrap: balance !important;
                      text-align: -webkit-center;
                    "
                  >
                    <span class="text-00a99d font-12">{{ item.title }}</span>
                  </v-col>
                </v-row>
              </v-list-item-icon>
              <v-list-item-icon style="height: auto" class="pb-1" v-else>
                <v-row>
                  <v-col
                    cols="12"
                    class="pt-3 pb-0"
                    style="align-items: center; text-align: -webkit-center"
                  >
                    <v-img
                      :alt="item.alt"
                      :src="require(`@/assets/icon/${item.img}`)"
                      width="25px"
                      height="25px"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    class="pt-0 pb-1"
                    style="
                      text-wrap: balance !important;
                      text-align: -webkit-center;
                    "
                  >
                    <span class="text-white font-12">{{ item.title }}</span>
                  </v-col>
                </v-row>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item
              v-else
              dark
              active-class="hover-menu-bar"
              :to="item.path"
              @click="activeTab(index)"
            >
              <v-list-item-icon
                v-if="tab === index"
                style="height: auto"
                class="pb-1"
              >
                <v-row>
                  <v-col
                    cols="12"
                    class="pt-3 pb-0"
                    style="align-items: center; text-align: -webkit-center"
                  >
                    <v-img
                      :alt="item.alt"
                      :src="require(`@/assets/icon/${item.imgActive}`)"
                      width="25px"
                      height="25px"
                    />
                  </v-col>
                  <v-col
                    v-if="item.title != 'ชำระเงิน'"
                    cols="12"
                    class="pt-0 pb-1"
                    style="
                      text-wrap: balance !important;
                      text-align: -webkit-center;
                    "
                  >
                    <span class="text-00a99d font-12">{{ item.title }}</span>
                  </v-col>
                  <v-col
                    v-else
                    cols="12"
                    class="pt-0 pb-1"
                    style="
                      text-wrap: nowrap !important;
                      text-align: -webkit-center;
                    "
                  >
                    <span class="text-00a99d font-12">{{ item.title }}</span>
                  </v-col>
                </v-row>
              </v-list-item-icon>
              <v-list-item-icon v-else style="height: auto" class="pb-1">
                <v-row>
                  <v-col
                    cols="12"
                    class="pt-3 pb-0"
                    style="align-items: center; text-align: -webkit-center"
                  >
                    <v-img
                      :alt="item.alt"
                      :src="require(`@/assets/icon/${item.img}`)"
                      width="25px"
                      height="25px"
                    />
                  </v-col>
                  <v-col
                    v-if="item.title != 'ชำระเงิน'"
                    cols="12"
                    class="pt-0 pb-1"
                    style="
                      text-wrap: balance !important;
                      text-align: -webkit-center;
                    "
                  >
                    <span class="text-white font-12">{{ item.title }}</span>
                  </v-col>
                  <v-col
                    v-else
                    cols="12"
                    class="pt-0 pb-1"
                    style="
                      text-wrap: nowrap !important;
                      text-align: -webkit-center;
                    "
                  >
                    <span class="text-white font-12">{{ item.title }}</span>
                  </v-col>
                </v-row>
              </v-list-item-icon>
            </v-list-item>
          </div>
        </div>
      </v-list>

      <template v-slot:append>
        <v-row justify="center">
          <v-col align="center" class="pb-8">
            <span class="text-white w-500 font-16">Version 1.1.15</span>
          </v-col>
        </v-row>
      </template>
    </v-navigation-drawer>

    <v-main class="pt-0">
      <v-container fluid class="pl-0 pt-0">
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import { EventBus } from "../EventBus";
import buttonSfx from "@/assets/sounds/pop-up-on.mp3";
import soundNoti from "@/assets/sounds/soundNoti.mp3";
var myTrack = new Audio(buttonSfx);
var trackNoti = new Audio(soundNoti);
export default {
  data() {
    return {
      nave: null,
      mini: false,
      messages: 0,
      statusnoti: false,
      unread: false,
      role: "",
      showManageClinic: false,
      myTrack,
      trackNoti,
      drawer: true,
      dialog: false,
      tab: 0,
      openTabTelemed: false,
      openTabDrug: false,
      openTab: false,
      selectClinic: [],
      getDataSelectClinic: [],
      orderDetail: [],
      orderDetail_unread: [],
      statusLoading: false,
      changeRole: null,
      btn_loading: false,
      items: [
        {
          title: "แจ้งเตือน 1",
        },
      ],
      itemsMed: [],
      itemsNurse: [],
      itemsPharmacist: [],
      itemsAdmin: [],
      rail: true,
      snackbar: false,
      snackbar_name: "",
      timeout: -1,
      status: false,
      hos_name: "",
      page: 1,
      pageUnread: 1,
      limit: 5,
      total: 10,
      roleList: [],
      itemNotification: [],
      Storage_bizid: sessionStorage.biz_id,
      test_conference: [],
      conUrl: "",
      hisId: "",
      patientName: "",
      channelName: "",
    };
  },
  sockets: {
    connect() {
      console.log("connect sockets io");
    },
    "conferences/callback-alert"(res) {
      try {
        console.log("callback-alert", res);
        (this.conUrl = res.receiverToken),
          (this.hisId = res.conferenceRef2),
          (this.patientName = res.patientName);
        if (
          res.receiverOneid == sessionStorage.account_id &&
          res.bizId == sessionStorage.biz_id
        ) {
          this.incomingCall();
          this.snackbar_name = res.staffName;
          this.snackbar = true;
        }
      } catch (err) {
        console.error("Error in callback-alert:", err);
      }
    },
    "conferences/hang_up"(res) {
      console.log("🚀 ~ res:", res);
      console.log("Ending Conference Success");
      // this.snackbar = false;
      // var audio = document.getElementById("audio");
      // audio.pause();
      // audio.currentTime = 0;

      if (
        res.biz_id == sessionStorage.biz_id &&
        res.receiver_oneid == sessionStorage.oneId
      ) {
        this.snackbar = false;
        var audio = document.getElementById("audio");
        audio.pause();
        audio.currentTime = 0;
      }
    },
    notiStaff(result) {
      try {
        if (result && Object.keys(result).length != 0) {
          switch (sessionStorage.role_name) {
            case "เภสัชกร":
              if (
                result.type === "check_drug" &&
                sessionStorage.oneId === result.recipient_oneid &&
                sessionStorage.role_name === result.role
              ) {
                this.orderDetail.unshift(result);
                this.orderDetail_unread.unshift(result);
                if (this.snackbar == false) {
                  this.playSoundNoti();
                }
              } else if (result.recipient_oneid === "all") {
                this.orderDetail.unshift(result);
                this.orderDetail_unread.unshift(result);
                if (this.snackbar == false) {
                  this.playSoundNoti();
                }
              }
              break;
            case "แพทย์":
              if (
                result.type !== "check_drug" &&
                sessionStorage.oneId === result.recipient_oneid &&
                sessionStorage.role_name === result.role
              ) {
                this.orderDetail.unshift(result);
                this.orderDetail_unread.unshift(result);
                if (this.snackbar == false) {
                  this.playSoundNoti();
                }
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        console.error("Error in notiStaff:", err);
      }
    },
  },

  async created() {
    if (
      sessionStorage.role_name == "แพทย์" ||
      sessionStorage.role_name == "เภสัชกร"
    ) {
      this.getSelectHospital();
      this.getDataList();
      this.getDataListUnread();
    } else if (
      (sessionStorage.role_name == "พยาบาล" ||
        sessionStorage.role_name == "เจ้าหน้าที่เวชระเบียน") &&
      sessionStorage.biz_id == "668236676897760"
    ) {
      this.getDataList();
      this.getDataListUnread();
    }
    await this.checkRole();
    this.selectClinic = sessionStorage.biz_id;
    this.showManageClinic =
      this.selectClinic == "324265892276395" ? true : false;
    this.hos_name = sessionStorage.biz_name;
    // if (!sessionStorage.biz_name.split("โรงพยาบาล")[1]) {
    //   this.hos_name = `รง.${sessionStorage.biz_name.split("สถานประกอบการ")[1]}`;
    //   this.hos_name = sessionStorage.biz_name;
    // }
    const payload = {
      biz_id: this.selectClinic,
    };
    await this.$store.dispatch("getOrganizationAction", payload);
    await this.permission_biz();
    let checktab = this.itemsPermission.findIndex((ele) =>
      this.current_path.includes(ele.path)
    );
    if (checktab > -1) {
      this.tab = checktab;
    } else {
      this.tab = null;
    }
  },
  watch: {
    statusReady(val) {
      this.status = val;
    },
  },
  mounted() {
    // EventBus.$on("statusCall", () => {
    //   this.status = true;
    //   this.changeStatusWorking_call(this.status);
    // });
    this.status = true;
    this.changeStatusWorking_call(this.status);
    this.historyBiz();
    window.addEventListener("unload", this.handleUnload);
  },
  beforeDestroy() {
    window.removeEventListener("unload", this.handleUnload);
    EventBus.$off("statusCall");
  },
  computed: {
    ...mapState([
      "profile",
      "biz",
      "statusReady",
      "itemsPermission",
      "loginWithRedirect",
    ]),
    ...mapGetters("master", ["getUsersGetter"], "bizId"),
    ...mapGetters({
      organization_vuex: "organizationGetter" || [],
    }),
    x_mobile: {
      get: function () {
        if (this.$vuetify.breakpoint.width <= 415) {
          return true;
        } else {
          return false;
        }
      },
      set: function (newValue) {
        this.nav = newValue;
      },
    },
    current_path() {
      return this.$route.fullPath;
    },
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 1372) {
        return true;
      } else {
        return false;
      }
    },

    xs_mode() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    sm_mode() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    is_doctor() {
      return sessionStorage.getItem("role_name") === "แพทย์";
    },
  },
  methods: {
    ...mapMutations("doctor", ["set_doctor_sign_img"]),
    ...mapMutations([
      "clearStateLogin",
      "setHealthCheck_notification",
      "setType_notification",
      "setStatusReady",
      "setDetailConference",
      "setRedirect",
    ]),
    test() {
      var audio = document.getElementById("audio");
      audio.play();
    },
    playSound() {
      this.myTrack.play();
      this.statusnoti = false;
    },
    playSoundNoti() {
      this.getDataList();
      this.getDataListUnread();
      this.trackNoti.play();
    },
    async getSelectHospital() {
      try {
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/staffs/biz?one_id=${sessionStorage.oneId}&role=${sessionStorage.role_name}`
          )
          .then((res) => {
            if (res.status == 200) {
              this.getDataSelectClinic = res.data.data;
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },

    // --- Notification ---
    getDataList($state) {
      this.axios
        .get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/noti-staff/all?recipient_oneid=${sessionStorage.oneId}&biz_id=${sessionStorage.biz_id}&role=${sessionStorage.role_name}&page=${this.page}&limit=${this.limit}`
        )
        .then((res) => {
          if (res.data.data) {
            const orderMessagesDetail = res.data.data[0].metadata[0].un_read;
            this.messages = orderMessagesDetail;
            if (res.data.data[0].data.length) {
              this.page += 1;
              setTimeout(() => {
                this.orderDetail.push(...res.data.data[0].data);
                if ($state) $state.loaded();
              }, 1000);
            } else {
              if ($state) $state.complete();
            }
          }
        });
    },
    getDataListUnread($state) {
      this.axios
        .get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/noti-staff/all-unread?recipient_oneid=${sessionStorage.oneId}&biz_id=${sessionStorage.biz_id}&role=${sessionStorage.role_name}&page=${this.pageUnread}&limit=${this.limit}`
        )
        .then((res) => {
          if (res.data.data) {
            if (res.data.data[0].data.length) {
              this.pageUnread += 1;
              setTimeout(() => {
                this.orderDetail_unread.push(...res.data.data[0].data);
                if ($state) $state.loaded();
              }, 1000);
            } else {
              if ($state) $state.complete();
            }
          }
        });
    },
    formatDateTime(data) {
      if (!data) {
        return null;
      }
      let datetime = new Date(
        new Date(data) - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, -1)
        .substr(0, 16);
      var [date, time] = datetime.split("T");
      var [year, month, day] = date.split("-");
      return `${day}/${month}/${parseInt(year) + 543} ${time}`;
    },
    selectNotification(item) {
      this.statusnoti = true;
      if (item.is_read == false) {
        this.axios
          .put(
            `${process.env.VUE_APP_BACKEND_URL}/v1/noti-staff/read/${item._id}`
          )
          .then(async (res) => {
            if (res.status == 200 && res.data) {
              if (
                item.type == "appointment" ||
                item.type.includes("drug") ||
                item.type == "take_history"
              ) {
                if (window.location.pathname !== `/main`) {
                  item.is_read = true;

                  this.setType_notification(item);
                  this.$router.replace({ name: "e-vaccineMain" });
                } else {
                  item.is_read = true;
                  EventBus.$emit("searchNotification", item.type);
                }
              } else if (item.type == "health_check") {
                if (window.location.pathname !== `/health-check`) {
                  item.is_read = true;
                  this.setHealthCheck_notification(item);
                  this.$router.replace({ name: "health-check" });
                } else {
                  item.is_read = true;
                  EventBus.$emit("searchNotification", item);
                }
              } else if (item.type == "med_cer") {
                if (window.location.pathname !== `/medicalcertificate`) {
                  item.is_read = true;
                  this.$router.replace({ name: "medical certificate" });
                } else {
                  item.is_read = true;
                  EventBus.$emit("searchNotification", item);
                }
              }
            }
            item.is_read = true;
            this.getDataList();
            this.getDataListUnread();
          });
      } else {
        if (item.type == "appointment" || item.type.includes("drug")) {
          if (window.location.pathname !== `/main`) {
            this.setType_notification(item);
            this.$router.replace({ name: "e-vaccineMain" });
          } else {
            EventBus.$emit("searchNotification", item.type);
          }
        } else if (item.type == "health_check") {
          if (window.location.pathname !== `/health-check`) {
            this.setHealthCheck_notification(item);
            this.$router.replace({ name: "health-check" });
          } else {
            EventBus.$emit("searchNotification", item);
          }
        } else if (item.type == "med_cer") {
          if (window.location.pathname !== `/medicalcertificate`) {
            this.$router.replace({ name: "medical certificate" });
          } else {
            EventBus.$emit("searchNotification", item);
          }
        }
        item.is_read = true;
        this.getDataList();
        this.getDataListUnread();
      }
    },

    // ------------
    async historyBiz() {
      try {
        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("limit", this.page);
        params.append("limit", 10);

        const { data: { data, result } = {} } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/history-biz?${params}`
        );
        if (result == "success") {
          if (data[0]) {
            const { data: searchData, metadata } = data[0];
            const { total } = metadata[0];
            this.total = total;
            this.items = searchData;
          }
        }
      } catch (error) {
        console.error();
      }
    },
    changBiz_id() {
      let return_data = [];
      if (this.getDataSelectClinic) {
        this.getDataSelectClinic.map((element) => {
          if (element.biz_id === this.selectClinic) {
            return_data.push(element);
          }
        });
        sessionStorage.biz_name = return_data[0].first_name_th;
        this.hos_name = sessionStorage.biz_name.split("โรงพยาบาล")[1];
      }

      sessionStorage.biz_id = this.selectClinic;
      window.location.reload();
    },
    checkRole() {
      if (window && window.sessionStorage) {
        this.role = sessionStorage.role_name;
      }
    },
    activeTab(index) {
      this.historyBiz();
      this.tab = index;
    },
    displayTemplate(key) {
      let data = this.profile;
      if (data) {
        if (key == "name") {
          return `${sessionStorage.accountName}`;
          // return `${data.accountDetail.first_name_th ? data.accountDetail.first_name_th : sessionStorage.accountName ? sessionStorage.accountName :""} ${data.accountDetail.last_name_th ? data.accountDetail.first_name_th : ""}`;
        }
        if (key == "bizId") {
          return this.biz.biz_name
            ? this.biz.biz_name
            : sessionStorage.biz_name
            ? sessionStorage.biz_name
            : "";
        }
        if (key == "role") {
          return this.role && this.role != "ehp_redirect"
            ? this.role
            : sessionStorage.role_name &&
              sessionStorage.role_name != "ehp_redirect"
            ? sessionStorage.role_name
            : this.role == "ehp_redirect" ||
              sessionStorage.role_name == "ehp_redirect"
            ? "EHP"
            : "";
        }
      }
    },
    openDialogRole() {
      this.$router.push("/");
      // --- ในกรณีที่เป็น Dialog แบบเปลี่ยนเอง -----
      // this.clinicData.forEach(element => {
      //     if (element.biz_id == sessionStorage.biz_id) {
      //         this.roleList = element.role.map(role => role);
      //         this.changeRole = this.role;
      //     }
      // });
      // this.dialog = true;
    },
    confirmChangeRole() {
      this.$swal
        .fire({
          title: "ยืนยันการเปลี่ยนสิทธิ์",
          text: "เปลี่ยนสิทธิ์ ต้องการยืนยันหรือไม่?",
          icon: "warning",
          width: 600,
          showCancelButton: true,
          confirmButtonColor: "#329d9c",
          cancelButtonColor: "#E53935",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res) {
            if (this.changeRole == this.role) {
              this.dialog = false;
            } else {
              this.btn_loading = true;
              setTimeout(() => {
                this.role = this.changeRole;
              }, 500);
              setTimeout(() => {
                this.btn_loading = false;
              }, 1000);
              sessionStorage.role_name = this.changeRole;
              this.dialog = false;
            }
          }
        });
    },
    logout() {
      this.$swal
        .fire({
          title:
            "<span style='color: black;font-size: 24px;font-family: Sarabun, sans-serif;'>ยืนยันการออกจากระบบ</span>",
          html: "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ออกจากระบบ ต้องการยืนยันหรือไม่?</span>",
          icon: "warning",
          width: 500,
          showCancelButton: true,
          confirmButtonColor: "#00a99d",
          cancelButtonColor: "#E53935",
          confirmButtonText:
            "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
          cancelButtonText:
            "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยกเลิก</span>",
          reverseButtons: true,
        })
        .then(async (res) => {
          if (res.value) {
            await this.offlineStatus(false);
            sessionStorage.clear();
            localStorage.removeItem("vuex");
            window.localStorage.removeItem("vuex");
            this.clearStateLogin();
            this.set_doctor_sign_img("");
            this.setRedirect("");
            this.$router.push("/");
          }
        });
    },
    incomingCall() {
      var audio = document.getElementById("audio");
      audio.play();
    },
    declineBtn() {
      this.snackbar = false;
      var audio = document.getElementById("audio");
      audio.pause();
      audio.currentTime = 0;
      this.$socket.connect();
    },
    openConference() {
      this.snackbar = false;
      this.status = false;
      this.changeStatusWorking_call(this.status);
      this.$router.push({
        name: "ConferenceDetail",
        query: {
          token: this.conUrl,
          patient_name: this.patientName,
          conference_id: this.hisId,
        },
      });
      // if (this.role == "แพทย์") {
      //   this.$router.push({ name: "ConferenceDetail" });
      // } else if (this.role == "พยาบาล") {
      //   this.$router.push({ name: "ConferenceDetail" });
      // }
      this.$socket.connect();
    },
    async changeStatusWorking_call(status) {
      let data = {
        one_id: sessionStorage.oneId,
        biz_id: sessionStorage.biz_id,
        role: sessionStorage.role_name,
        status: status,
      };
      this.axios
        .put(`${process.env.VUE_APP_BACKEND_URL}/v1/staffs/status`, data)
        .then((res) => {
          if (res.data) {
            this.setStatusReady(status);
          }
        });
    },
    async changeStatusWorking(status) {
      this.$swal
        .fire({
          title:
            "<span style='color: black;font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยันการเปลี่ยนสถานะ</span>",
          html: "<span style='color: black;font-size: 14px;font-family: Sarabun, sans-serif;'>ต้องการยืนยันยืนยันการเปลี่ยนสถานะหรือไม่?</span>",
          icon: "question",
          width: 400,
          background: "white",
          position: "center",
          showCancelButton: true,
          reverseButtons: true,
          cancelButtonText:
            "<span style='font-size: 14px;font-family: Sarabun, sans-serif;'>ยกเลิก</span>",
          cancelButtonColor: "#F5222D",
          confirmButtonText:
            "<span style='font-size: 14px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
          confirmButtonColor: "#329D9C",
          returnEmit: "confirm",
        })
        .then((res) => {
          let data = {
            one_id: sessionStorage.oneId,
            biz_id: sessionStorage.biz_id,
            role: sessionStorage.role_name,
            status: status,
          };
          if (res.isConfirmed) {
            this.axios
              .put(`${process.env.VUE_APP_BACKEND_URL}/v1/staffs/status`, data)
              .then((res) => {
                if (res.data) {
                  this.setStatusReady(status);
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "ไม่สำเร็จ",
                    text: "กรุณาลองใหม่อีกครั้ง",
                    timer: 3000,
                    showConfirmButton: false,
                    showCloseButton: false,
                  });
                }
              });
          } else if (res.dismiss === "backdrop" || res.isConfirmed === false) {
            this.status = this.statusReady;
            return;
          }
        });
    },

    handleUnload(event) {
      this.offlineStatus(false);
      event.returnValue = "Are you sure you want to leave this page?";
    },

    offlineStatus(status) {
      let data = {
        one_id: sessionStorage.oneId,
        biz_id: sessionStorage.biz_id,
        role: sessionStorage.role_name,
        status: status,
      };
      this.axios
        .put(`${process.env.VUE_APP_BACKEND_URL}/v1/staffs/status`, data)
        .then((res) => {
          if (res.data) {
            this.setStatusReady(status);
          }
        });
    },
    go_to_doctor_profile() {
      if (this.$router.currentRoute.fullPath !== "/doctor-profile") {
        this.$router.push("/doctor-profile");
      }
    },
    changeRoleAndBiz() {
      // this.$router.push({ name: "DashboardNurse" });
      this.$router.push("/?save=true");
    },
    displayNotiCall(item) {
      const {
        send_by: { role } = {},
        sender_oneid,
        receiver_oneid,
        nurse,
        doctor,
        patient,
      } = item;
      if (sender_oneid === undefined && receiver_oneid == undefined)
        return { show: false };
      if (role == "แพทย์") {
        if (nurse == null) {
          return {
            show: true,
            patient: `${patient.account_title_th} ${patient.first_name_th} ${patient.last_name_th}`,
            doctor: `${doctor.staff_first_name_th} ${doctor.staff_last_name_th}`,
          };
        } else {
          return {
            show: true,
            nurse: `${nurse.staff_first_name_th} ${nurse.staff_last_name_th}`,
            patient: `${patient.account_title_th} ${patient.first_name_th} ${patient.last_name_th}`,
            doctor: `${doctor.staff_first_name_th} ${doctor.staff_last_name_th}`,
          };
        }
      }

      if (role == "พยาบาล") {
        if (doctor == null) {
          return {
            show: true,
            patient: `${patient.account_title_th} ${patient.first_name_th} ${patient.last_name_th}`,
            nurse: `${nurse.staff_first_name_th} ${nurse.staff_last_name_th}`,
          };
        } else {
          return {
            show: true,
            nurse: `${nurse.staff_first_name_th} ${nurse.staff_last_name_th}`,
            patient: `${patient.account_title_th} ${patient.first_name_th} ${patient.last_name_th}`,
            doctor: `${doctor.staff_first_name_th} ${doctor.staff_last_name_th}`,
          };
        }
      }

      // console.log(
      // "🚀 ~ file: Navbar.vue:1106 ~ displayNotiCall ~ nurse, doctor, patient:",
      //   nurse,
      //   doctor,
      //   patient
      // );
      // console.log(
      // "🚀 ~ file: Navbar.vue:1106 ~ displayNotiCall ~ send_by:",
      //   role
      // );
    },
    async permission_biz() {
      const payload = {
        biz_id: sessionStorage.biz_id,
        role_name: sessionStorage.role_name,
      };
      await this.$store.dispatch("getPermissionsAction", payload);
    },
    itemsShow(items) {
      const isShow = items.some((element) => element.show == true);
      if (isShow) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");

.v-toolbar__content {
  display: flex;
}
.hover-menu-bar {
  /* background: linear-gradient(90deg, rgba(185,231,255,1) 14%, rgba(247,253,255,1) 100%); */
  background-color: #ffffff;
  /* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg %3E%3Cpath fill='%230cb7f5' d='M486 705.8c-109.3-21.8-223.4-32.2-335.3-19.4C99.5 692.1 49 703 0 719.8V800h843.8c-115.9-33.2-230.8-68.1-347.6-92.2C492.8 707.1 489.4 706.5 486 705.8z'/%3E%3Cpath fill='%233fc1f1' d='M1600 0H0v719.8c49-16.8 99.5-27.8 150.7-33.5c111.9-12.7 226-2.4 335.3 19.4c3.4 0.7 6.8 1.4 10.2 2c116.8 24 231.7 59 347.6 92.2H1600V0z'/%3E%3Cpath fill='%2370cdf0' d='M478.4 581c3.2 0.8 6.4 1.7 9.5 2.5c196.2 52.5 388.7 133.5 593.5 176.6c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9C268.4 537.4 375.7 554.2 478.4 581z'/%3E%3Cpath fill='%239edaf1' d='M0 0v429.4c55.6-18.4 113.5-27.3 171.4-27.7c102.8-0.8 203.2 22.7 299.3 54.5c3 1 5.9 2 8.9 3c183.6 62 365.7 146.1 562.4 192.1c186.7 43.7 376.3 34.4 557.9-12.6V0H0z'/%3E%3Cpath fill='%23C9E9F5' d='M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1c2.8 1.1 5.5 2.3 8.3 3.4c171 71.6 342.7 158.5 531.3 207.7c198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2C59 263.6 120.6 255.7 181.8 259.4z'/%3E%3Cpath fill='%23c9e9f5' d='M1600 0H0v136.3c62.3-20.9 127.7-27.5 192.2-19.2c93.6 12.1 180.5 47.7 263.3 89.6c2.6 1.3 5.1 2.6 7.7 3.9c158.4 81.1 319.7 170.9 500.3 223.2c210.5 61 430.8 49 636.6-16.6V0z'/%3E%3Cpath fill='%23c9e9f5' d='M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3c12.8-4.1 25.4-8.4 38.1-12.9V0H288.1c56 21.3 108.7 50.6 159.7 82C450.2 83.4 452.5 84.9 454.9 86.3z'/%3E%3Cpath fill='%23c9e9f5' d='M1600 0H498c118.1 85.8 243.5 164.5 386.8 216.2c191.8 69.2 400 74.7 595 21.1c40.8-11.2 81.1-25.2 120.3-41.7V0z'/%3E%3Cpath fill='%23c9e9f5' d='M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8c21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4C1020.4 178.1 1214.2 196.1 1397.5 154.8z'/%3E%3Cpath fill='%23C9E9F5' d='M1315.3 72.4c75.3-12.6 148.9-37.1 216.8-72.4h-723C966.8 71 1144.7 101 1315.3 72.4z'/%3E%3C/g%3E%3C/svg%3E"); */
}
.card-hosname {
  padding: 8px;
  background: #ceefed;
  border-radius: 20px 5px;
}
.card-hosname-text {
  background-color: white;
  padding: 8px;
  border-radius: 20px 5px;
}
::v-deep .v-list-item--link:before {
  background-color: #ffffff;
}

.v-list .v-list-item--active {
  color: #00a99d;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb:hover {
  columns: #ffffff;
  background-color: #d6dee1;
}

.rounded-card {
  background: #5bbeb5;
}

.card-profile {
  background: #ceefed;
  border-radius: 20px 5px;
}
.custom-topic {
  color: #ffffff !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  white-space: nowrap !important;
}

::v-deep .v-list-item--dense .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list--dense .v-list-item .v-list-item__subtitle {
  font-size: 16px;
  line-height: 1.5rem;
  font-weight: 400;
  margin-top: 5px;
}

::v-deep .v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 0px;
}

::v-deep
  .v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 35px !important;
}

::v-deep ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::v-deep .v-list--dense .v-list-item .v-list-item__content {
  padding: 8px 0;
  padding-left: 10px !important;
}
::v-deep .v-list-item__icon {
  display: inline-flex;
  min-width: auto !important;
  text-align: center;
}
::v-deep .v-list--nav {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.8rem !important;
}
</style>
